import script from "./BasicLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&setup=true&lang=ts"

import "./BasicLayout.vue?vue&type=style&index=0&id=6cb4beba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb4beba"]])

export default __exports__